module.exports = __webpack_public_path__ + "img/earth.c5aa8266.svg";